import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import { Section, Input, Button, Card } from '../components/ui';
import Header from './Header';
import Footer from './Footer';
import './Signup.css';

const Signup = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { signup } = useAuth();
    const navigate = useNavigate();

    const handleSignup = async (e) => {
        e?.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            await signup(email, password);
            alert('Signup successful! Please verify your email.');
            navigate('/login');
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            <Header variant="minimal" />
            <Section variant="large" className="auth-section">
                <div className="auth-container">
                    <motion.div
                        className="auth-header"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h1 className="auth-title">Sign up</h1>
                        <p className="auth-subtitle">Create your account to get started.</p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <Card variant="glass" className="auth-card">
                            <form className="auth-form" onSubmit={handleSignup}>
                                <Input
                                    type="email"
                                    name="email"
                                    label="Email"
                                    placeholder="your.email@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />

                                <Input
                                    type="password"
                                    name="password"
                                    label="Password"
                                    placeholder="Create a strong password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />

                                {error && (
                                    <motion.div
                                        className="auth-error"
                                        initial={{ opacity: 0, y: -10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                    >
                                        {error}
                                    </motion.div>
                                )}

                                <Button
                                    type="submit"
                                    variant="primary"
                                    size="lg"
                                    disabled={isLoading}
                                    className="auth-submit-button"
                                >
                                    {isLoading ? 'Creating account...' : 'Sign up'}
                                </Button>
                            </form>
                        </Card>

                        <div className="auth-footer-link">
                            <span className="auth-footer-text">Already have an account? </span>
                            <Link to="/login" className="auth-link">
                                Log in
                            </Link>
                        </div>
                    </motion.div>
                </div>
            </Section>
            <Footer />
        </div>
    );
};

export default Signup;